import { HumanFemaleIcon } from './HumanFemaleIcon';

/**
 * author: Google
 * id 059421A9-4F27-493A-8835-4B49B5286366
 * name human-female
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-female.svg
 * tags
 * - People / Family 
 */
export const WomanIcon = HumanFemaleIcon;
export default WomanIcon